export const CPD_UPDATED = 'CPD Details updated';
export const CPD_DELETED = 'CPDs deleted';
export const CPD_CREATED = 'CPD created';
export const MEMBERBODY_REQUIRED = 'Please select an Event Organizer first';
